import { Tooltip, TooltipContent, TooltipTrigger } from "../shadcn/tooltip";
import { cn } from "@/lib/utils";

/**
 * The one way to show a hint on hover or focus. Use it instead of composing shadcn Tooltip, TooltipTrigger and TooltipContent by hand, or StatusTooltip.
 *
 * @import import { NoxusTooltip } from "@/components/UI/NoxusTooltip";
 */
const NoxusTooltip = ({
  children,
  content,
  placement = "top",
  isDisabled = false,
  asChild = false,
  align = "center",
  delayDuration,
  zIndex,
  classNameTrigger,
  sideOffset,
  classNameContent,
}: {
  children: React.ReactNode;
  content: string | React.ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
  align?: "start" | "end" | "center";
  isDisabled?: boolean;
  asChild?: boolean;
  delayDuration?: number;
  zIndex?: number;
  classNameTrigger?: string;
  sideOffset?: number;
  classNameContent?: string;
}) => {
  if (isDisabled || !content) {
    return <>{children}</>;
  }
  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger
        asChild={asChild}
        className={classNameTrigger}
        tabIndex={-1}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent
        side={placement}
        sideOffset={sideOffset}
        className={cn("max-w-xs", classNameContent)}
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
};

export { NoxusTooltip };
